import { IconButtonTestIdFactory } from '../../buttons/interactions';
export const AccordionStates = {
    Disabled: 'disabled',
    Active: 'active',
};
export const AccordionTestIdFactory = {
    getAccordionBase: () => 'accordion',
    getAccordionHeaderBase: () => [AccordionTestIdFactory.getAccordionBase(), 'header'].join('-'),
    getAccordionGroupBase: () => [AccordionTestIdFactory.getAccordionBase(), 'group'].join('-'),
    getAccordionPanelBase: () => [AccordionTestIdFactory.getAccordionBase(), 'panel'].join('-'),
    getAccordionTestId: (testId) => [AccordionTestIdFactory.getAccordionBase(), testId].join('-'),
    getAccordionHeaderTestId: (testId) => [AccordionTestIdFactory.getAccordionHeaderBase(), testId].join('-'),
    getAccordionHeaderButtonTestId: (testId) => IconButtonTestIdFactory.getIconButtonTestId(testId),
    getAccordionPanelTestId: (testId) => [AccordionTestIdFactory.getAccordionPanelBase(), testId].join('-'),
    getAccordionGroupTestId: (testId) => [AccordionTestIdFactory.getAccordionGroupBase(), testId].join('-'),
};
